<template lang="pug">
.loader(v-if="!done", :class="{ hidden: !loading }")
  .loader__inner
    .loader__row
      .loader__block.loader__block--outer-16
      .loader__block.loader__block--outer-15
      .loader__block.loader__block--outer-14
      .loader__block.loader__block--outer-13
      .loader__block.loader__block--outer-12
    .loader__row
      .loader__block.loader__block--outer-1
      .loader__block.loader__block--inner-6
      .loader__block.loader__block--inner-5
      .loader__block.loader__block--inner-4
      .loader__block.loader__block--outer-11
    .loader__row
      .loader__block.loader__block--outer-2
      .loader__block.loader__block--inner-1
      .loader__block.loader__block--inner-2
      .loader__block.loader__block--inner-3
      .loader__block.loader__block--outer-10
    .loader__row
      .loader__block.loader__block--outer-3
      .loader__block.loader__block--inner-7
      .loader__block.loader__block--inner-8
      .loader__block.loader__block--inner-9
      .loader__block.loader__block--outer-9
    .loader__row
      .loader__block.loader__block--outer-4
      .loader__block.loader__block--outer-5
      .loader__block.loader__block--outer-6
      .loader__block.loader__block--outer-7
      .loader__block.loader__block--outer-8
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Loader",
  data() {
    return {
      done: false
    }
  },
  computed: {
    ...mapGetters(['loading', 'error'])
  },
  methods: {
    hideLoader() {
      if (!this.loading) {
        setTimeout(() => {
          this.done = true;
        }, 2500);
      }
    }
  },
  watch: {
    loading() {
      this.hideLoader();
    }
  }
};
</script>

<style lang="scss" scoped>
$color: $blue;
$color-secondary: $red;
$size: clamp(1.25rem, 3vw, 3rem);
$time: 2.5;

.loader {
  width: 100vw;
  height: 100vh;
  background: $lightGray;
  position: fixed;
  inset: 0;
  z-index: 20;
  &.hidden {
    animation: fade 0.25s 0.75s ease-out forwards;
    pointer-events: none;
  }

  &__inner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
    width: 100%;
    .hidden & {
      animation: scale 1.25s ease-out forwards,
        exploadX 0.75s 0.625s forwards ease-out;
    }
  }

  &__row {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    .hidden & {
      animation: exploadY 0.75s 0.625s forwards ease-out;
    }
  }

  &__block {
    width: $size;
    height: $size;
    background: $color;
    position: relative;
    border-radius: 0.5rem;

    @for $i from 1 through 16 {
      &--outer-#{$i} {
        animation: phase #{$time + s} #{- math.div($time, 18) * $i + s} infinite;
      }
    }

    @for $i from 1 through 9 {
      &--inner-#{$i} {
        @if $i != 2 {
          animation: phase #{$time + s} #{- math.div($time, 6) * $i + s} infinite;
        } @else {
          opacity: 0;
        }
      }
    }
  }
}

@keyframes phase {
  0% {
    background: $color;
  }
  30% {
    background: $color-secondary;
    transform: scale(0.75);
    border-radius: 50%;
  }
  100% {
    background: $color;
  }
}

@keyframes scale {
  50% {
    transform: translate(-50%, -50%) scale(0.75, 0.75);
    opacity: 1;
  }
  90% {
    opacity: 0;
  }
  100% {
    transform: translate(-50%, -50%) scale(5, 5);
    opacity: 0;
  }
}

@keyframes fade {
  100% {
    background: transparent;
  }
}

@keyframes exploadX {
  to {
    gap: 20vmin;
  }
}
@keyframes exploadY {
  to {
    gap: 10vmin;
  }
}
</style>
